import { SessionStorage } from "./AppStorage.js";
const lastCheckDeviceHeaders = "lastCheckDeviceHeaders";
const getDeviceLocationHeaders = () => {
  const headersDeviceParse = SessionStorage.get(lastCheckDeviceHeaders);
  return headersDeviceParse;
};
export {
  getDeviceLocationHeaders,
  lastCheckDeviceHeaders
};
